/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateYoutubeVideoConfigReqVo,
  ResponseListYoutubeVideoConfigInfoRespVo,
  ResponseLong,
  ResponsePageDataYoutubeVideoConfigInfoRespVo,
  ResponseYoutubeVideoConfigInfoRespVo,
  UpdateYoutubeVideoConfigEnableReqVo,
  UpdateYoutubeVideoConfigReqVo,
} from '../models/index';
import {
    CreateYoutubeVideoConfigReqVoFromJSON,
    CreateYoutubeVideoConfigReqVoToJSON,
    ResponseListYoutubeVideoConfigInfoRespVoFromJSON,
    ResponseListYoutubeVideoConfigInfoRespVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePageDataYoutubeVideoConfigInfoRespVoFromJSON,
    ResponsePageDataYoutubeVideoConfigInfoRespVoToJSON,
    ResponseYoutubeVideoConfigInfoRespVoFromJSON,
    ResponseYoutubeVideoConfigInfoRespVoToJSON,
    UpdateYoutubeVideoConfigEnableReqVoFromJSON,
    UpdateYoutubeVideoConfigEnableReqVoToJSON,
    UpdateYoutubeVideoConfigReqVoFromJSON,
    UpdateYoutubeVideoConfigReqVoToJSON,
} from '../models/index';

export interface WebConfigYoutubeVideoIdDeleteRequest {
    id: number;
}

export interface WebConfigYoutubeVideoIdEnablePutRequest {
    id: number;
    updateYoutubeVideoConfigEnableReqVo?: UpdateYoutubeVideoConfigEnableReqVo;
}

export interface WebConfigYoutubeVideoIdGetRequest {
    id: number;
}

export interface WebConfigYoutubeVideoIdPutRequest {
    id: number;
    updateYoutubeVideoConfigReqVo?: UpdateYoutubeVideoConfigReqVo;
}

export interface WebConfigYoutubeVideoPageGetRequest {
    currentPage: number;
    pageSize: number;
    keyword?: string;
    enable?: number;
}

export interface WebConfigYoutubeVideoPostRequest {
    createYoutubeVideoConfigReqVo?: CreateYoutubeVideoConfigReqVo;
}

/**
 * 
 */
export class YouTubeYoutubeVideoConfigControllerApi extends runtime.BaseAPI {

    /**
     * 软删除视频 YouTube视频管理·删除视频
     * YouTube视频管理·删除视频
     */
    async webConfigYoutubeVideoIdDeleteRaw(requestParameters: WebConfigYoutubeVideoIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigYoutubeVideoIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/youtube-video/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 软删除视频 YouTube视频管理·删除视频
     * YouTube视频管理·删除视频
     */
    async webConfigYoutubeVideoIdDelete(requestParameters: WebConfigYoutubeVideoIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigYoutubeVideoIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 启用或停用视频 YouTube视频管理·启停视频
     * YouTube视频管理·启停视频
     */
    async webConfigYoutubeVideoIdEnablePutRaw(requestParameters: WebConfigYoutubeVideoIdEnablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigYoutubeVideoIdEnablePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/youtube-video/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateYoutubeVideoConfigEnableReqVoToJSON(requestParameters['updateYoutubeVideoConfigEnableReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 启用或停用视频 YouTube视频管理·启停视频
     * YouTube视频管理·启停视频
     */
    async webConfigYoutubeVideoIdEnablePut(requestParameters: WebConfigYoutubeVideoIdEnablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigYoutubeVideoIdEnablePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 按编号查询未删除视频 YouTube视频管理·视频详情
     * YouTube视频管理·视频详情
     */
    async webConfigYoutubeVideoIdGetRaw(requestParameters: WebConfigYoutubeVideoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseYoutubeVideoConfigInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigYoutubeVideoIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/youtube-video/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseYoutubeVideoConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 按编号查询未删除视频 YouTube视频管理·视频详情
     * YouTube视频管理·视频详情
     */
    async webConfigYoutubeVideoIdGet(requestParameters: WebConfigYoutubeVideoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseYoutubeVideoConfigInfoRespVo> {
        const response = await this.webConfigYoutubeVideoIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改视频内容 YouTube视频管理·修改视频
     * YouTube视频管理·修改视频
     */
    async webConfigYoutubeVideoIdPutRaw(requestParameters: WebConfigYoutubeVideoIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigYoutubeVideoIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/youtube-video/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateYoutubeVideoConfigReqVoToJSON(requestParameters['updateYoutubeVideoConfigReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 修改视频内容 YouTube视频管理·修改视频
     * YouTube视频管理·修改视频
     */
    async webConfigYoutubeVideoIdPut(requestParameters: WebConfigYoutubeVideoIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigYoutubeVideoIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 官网已启用视频列表，免登录 YouTube视频管理·官网列表（免登录）
     * YouTube视频管理·官网列表（免登录）
     */
    async webConfigYoutubeVideoListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListYoutubeVideoConfigInfoRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/youtube-video/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListYoutubeVideoConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 官网已启用视频列表，免登录 YouTube视频管理·官网列表（免登录）
     * YouTube视频管理·官网列表（免登录）
     */
    async webConfigYoutubeVideoListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListYoutubeVideoConfigInfoRespVo> {
        const response = await this.webConfigYoutubeVideoListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 管理端分页查询 YouTube视频管理·分页列表
     * YouTube视频管理·分页列表
     */
    async webConfigYoutubeVideoPageGetRaw(requestParameters: WebConfigYoutubeVideoPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataYoutubeVideoConfigInfoRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling webConfigYoutubeVideoPageGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling webConfigYoutubeVideoPageGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/youtube-video/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataYoutubeVideoConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 管理端分页查询 YouTube视频管理·分页列表
     * YouTube视频管理·分页列表
     */
    async webConfigYoutubeVideoPageGet(requestParameters: WebConfigYoutubeVideoPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataYoutubeVideoConfigInfoRespVo> {
        const response = await this.webConfigYoutubeVideoPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 新增 YouTube 推广视频 YouTube视频管理·新增视频
     * YouTube视频管理·新增视频
     */
    async webConfigYoutubeVideoPostRaw(requestParameters: WebConfigYoutubeVideoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/youtube-video`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateYoutubeVideoConfigReqVoToJSON(requestParameters['createYoutubeVideoConfigReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 新增 YouTube 推广视频 YouTube视频管理·新增视频
     * YouTube视频管理·新增视频
     */
    async webConfigYoutubeVideoPost(requestParameters: WebConfigYoutubeVideoPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigYoutubeVideoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
